// @flow

import { compose } from 'redux'
import { withPayments } from 'src/decorators'
import PaymentCard from './PaymentCard'

export default compose(
  withPayments,
)(PaymentCard)
